import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Tên cấu hình'),
        key:'name',
        width: 150,
    }, {
        title:Util.L('Ngày hiệu lực'),
        key:'creationTime',
        width: 170,
        align: 'center',
        render:(h:any,params:any)=> { return h("span", Util.toViewDatePickerString(params.row.effectiveDate)); }
    },
    {
        title:Util.L('Ngày hết hạn'),
        key:'creationTime',
        width: 170,
        align: 'center',
        render:(h:any,params:any)=> { return h("span",params.row.expiredDate ? Util.toViewDatePickerString(params.row.expiredDate) : null); }
    },
    {
        title:Util.L('Ngày tạo'),
        key:'creationTime',
        width: 170,
        render:(h:any,params:any)=> { return h("span", Util.toViewDateString(params.row.creationTime)); }
    },
    {
        title:Util.L('Người tạo'),
        key:'creatorUserFullName',
        width: 150,
        render:(h:any,params:any)=> { return h("span",!_.isEmpty(_.get(params,'row.creatorUser.userName')) ? _.get(params,'row.creatorUser.userName','') + ' - ' + _.get(params,'row.creatorUser.name','') : null) }
    },
    {
        title:Util.L('Ngày cập nhật'),
        key:'lastModificationTime',
        width: 170,
        render:(h:any,params:any)=> { return h("span",params.row.lastModificationTime ? Util.toViewDateString(params.row.lastModificationTime) : null); }
    },
    {
        title:Util.L('Người cập nhật'),
        key:'lastModifierUserFullName',
        width: 150,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.lastModifierUser.userName')) ? _.get(params,'row.lastModifierUser.userName','') + ' - ' + _.get(params,'row.lastModifierUser.name','') : null) }
    },{
        title: Util.L('Action'),
        width:150,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]